import React from "react";
import { Link } from "react-router-dom";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 18,
  padding: "1rem",
};

const bookings = [
  {
    id: "BK-1001",
    customer: "Aisha Khan",
    service: "Haircut and beard trim",
    date: "2026-08-06 11:00",
    status: "REQUESTED",
    stylist: "Unassigned",
  },
  {
    id: "BK-1002",
    customer: "Neha Sharma",
    service: "Bridal makeup trial",
    date: "2026-08-06 14:30",
    status: "ACCEPTED",
    stylist: "Riya Kaur",
  },
  {
    id: "BK-1003",
    customer: "Aman Gill",
    service: "Skin fade",
    date: "2026-08-07 10:00",
    status: "COMPLETED",
    stylist: "Aman Deep",
  },
];

export default function ProviderBookingsPage() {
  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <h2 style={{ margin: 0, color: "#0f172a" }}>Bookings</h2>
        <p style={{ margin: "0.5rem 0 0", color: "#475569", lineHeight: 1.7 }}>
          Review requested, accepted, completed, cancelled, and disputed bookings from the provider side.
        </p>
      </section>

      {bookings.map((booking) => (
        <section key={booking.id} style={cardStyle}>
          <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem", flexWrap: "wrap" }}>
            <div>
              <h3 style={{ margin: 0, color: "#0f172a" }}>
                {booking.customer} · {booking.service}
              </h3>
              <p style={{ margin: "0.45rem 0 0", color: "#475569" }}>
                {booking.date} · Stylist: {booking.stylist}
              </p>
              <p style={{ margin: "0.35rem 0 0", color: "#334155", fontWeight: 700 }}>
                Status: {booking.status}
              </p>
            </div>

            <Link
              to={`/provider/dashboard/bookings/${booking.id}`}
              style={{
                alignSelf: "center",
                textDecoration: "none",
                border: "1px solid #d1d5db",
                borderRadius: 12,
                padding: "0.75rem 1rem",
                color: "#111827",
                fontWeight: 700,
              }}
            >
              View booking
            </Link>
          </div>
        </section>
      ))}
    </div>
  );
}